import { userConstants } from '../constants/user.constants'

export function authentication(state = { loggedIn: false, user: {} }, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return Object.assign({}, state, {
        loggingIn: true,
        user: action.user
      })
    case userConstants.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        loggedIn: true,
        user: action.user
      })
    case userConstants.LOGIN_FAILURE:
      return {}
    case userConstants.LOGOUT:
      return undefined
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/authentication.reducer.js